module.exports = __webpack_public_path__ + "img/84.2dc375b9.jpg";